import FlexBox from '@sharedComponents/FlexBox';
import Typography from '@sharedComponents/Typography';
import { Trans, useTranslation } from 'react-i18next';

const FormGroup = ({ label = '', children, errorMsg = '', optionnal = false, hint = '', isDisabled = false, helperText = '' }) => {
    const { t } = useTranslation();
    const suffix = optionnal ? t('Optionnal') : hint;
    return (
        <FlexBox flexDirection="column" gap="xs">
            {label && (
                <Typography color={isDisabled ? 'disabled' : errorMsg ? 'error-primary' : 'neutral-primary'} fontWeight="regular">
                    <Trans
                        i18nKey={!suffix ? label : label + ` <0>${suffix}<0>`}
                        components={[<span key="optionnal" style={{ color: 'var(--text-color-neutral-tertiary)' }} />]}
                    />
                </Typography>
            )}
            {children}
            {errorMsg && (
                <Typography color={'error-primary'} fontWeight="regular" fontSize="xs">
                    {errorMsg}
                </Typography>
            )}
            {!errorMsg && helperText && (
                <Typography color="neutral-secondary" fontWeight="regular" fontSize="xs">
                    {helperText}
                </Typography>
            )}
        </FlexBox>
    );
};

export default FormGroup;
